import React, { useEffect, useState } from 'react'

import styles from './styles.module.scss'
import cn from 'classnames'

import Products from './Products/Products'
import Form from './Form/Form'
import UnsubscribeForm from '../Popups/UnsubscribeForm/UnsubscribeForm'
import PendingPaymentPopup from '../Popups/PendingPaymentPopup/PendingPaymentPopup'
import PopupNotify from '../Popups/PopupNotify/PopupNotify'
import Spinner from '../../../UI/Spinner/Spinner'

import useServicesStore from './useServicesStore'
import { getBillingSettingsGlobal, getPublicStripeKey } from '../../../api/getApi'
import { notify } from '../../../helpers/notify'
import DisabledStore from '../../DisabledStore/DisabledStore'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

const Services = ({ containerRef }) => {
  const [sum, setSum] = useState(0)

  const [options, setOptions] = useState({
    mode: 'subscription',
    amount: sum > 0 ? sum : (sum + 1) * 100,
    currency: 'usd',
    paymentMethodCreation: 'manual',
    setupFutureUsage: 'off_session',
    appearance: {
      variables: {
        borderRadius: '4px',
      },
    },
  })

  const stripe = async () => {
    try {
      const { public_key } = await getPublicStripeKey()

      return loadStripe(public_key, { locale: 'en' })
    } catch (error) {
      notify.errorsList(error.errors)
    }
  }

  useEffect(() => {
    if (sum > 0) setOptions({ ...options, amount: sum })
    //eslint-disable-next-line
  }, [sum])

  return (
    <Elements stripe={stripe()} options={options}>
      <ServicesWrapper containerRef={containerRef} setSum={setSum} />
    </Elements>
  )
}

const ServicesWrapper = ({ setSum, containerRef }) => {
  const [isBillingActive, setIsBillingActive] = useState(null)

  useEffect(() => {
    const getBillingSettingsData = async () => {
      try {
        const { is_active } = await getBillingSettingsGlobal()

        setIsBillingActive(is_active)
      } catch (error) {
        notify.errorsList(error.errors)
      }
    }

    getBillingSettingsData()
  }, [])

  const {
    stripe,
    elements,

    card,
    billingDetails,
    products,

    markedUnpaidProductsId,
    markedPaidProductsId,
    unProlongedProducts,
    unsubscribeProduct,
    setMarkedPaidProductsId,
    setUnProlongedProducts,
    updateProductsByEmailSubscription,

    popup,
    successProcessPayment,
    unSuccessProcessPayment,
    serviceEmailSubscription,

    pendingPaymentData,
    setPendingPaymentData,

    filters,
    totalPrice,
    totalPriceForButton,

    loading,
    isPriceLoading,
    isActiveUnsubscribeForm,

    handleSubmit,
    handleCheckBoxClick,
    handleCardDetach,
    handleReadyButtons,

    handlePopupClose,
    handleUnsubscribeFormClose,
    currentProductId,
    paddingBottom,
  } = useServicesStore()

  useEffect(() => {
    if (totalPriceForButton > 0) setSum(totalPriceForButton)
  }, [setSum, totalPriceForButton, markedUnpaidProductsId, markedPaidProductsId, isPriceLoading])

  return (
    <>
      {!loading && !isBillingActive && <DisabledStore />}

      <div className={cn(styles.main, { [styles.slideIn]: !loading })}>
        {loading && <Spinner size={100} />}

        {!loading && isBillingActive && (
          <>
            <Products
              onCheckBoxClick={handleCheckBoxClick}
              serviceEmailSubscription={serviceEmailSubscription}
              updateProductsByEmailSubscription={updateProductsByEmailSubscription}
              products={products}
              markedPaidIds={markedPaidProductsId}
              markedUnpaidIds={markedUnpaidProductsId}
              unProlongedProducts={unProlongedProducts}
              currentProductId={currentProductId}
              isPriceLoading={isPriceLoading}
            />

            <Form
              stripe={stripe}
              elements={elements}
              onSubmit={handleSubmit}
              onReady={handleReadyButtons}
              onCardDetach={handleCardDetach}
              countries={filters.countries}
              card={card}
              billingDetails={billingDetails}
              sum={totalPrice}
              markedPaidIds={markedPaidProductsId}
              markedUnpaidIds={markedUnpaidProductsId}
              isLoadingSum={isPriceLoading}
              totalPriceForButton={totalPriceForButton}
              paddingBottom={paddingBottom}
              containerRef={containerRef}
            />

            {isActiveUnsubscribeForm && (
              <UnsubscribeForm
                reasons={filters.reasons}
                product={unsubscribeProduct}
                successProcessPayment={successProcessPayment}
                unSuccessProcessPayment={unSuccessProcessPayment}
                updateMarkedPaidIds={setMarkedPaidProductsId}
                updateUnProlongedProducts={setUnProlongedProducts}
                onClose={handleUnsubscribeFormClose}
              />
            )}

            {Boolean(pendingPaymentData) && (
              <PendingPaymentPopup
                stripe={stripe}
                data={pendingPaymentData}
                updatePendingPaymentData={setPendingPaymentData}
                successProcessPayment={successProcessPayment}
                unSuccessProcessPayment={unSuccessProcessPayment}
              />
            )}

            {popup.isActive && <PopupNotify onClose={handlePopupClose} {...popup} />}
          </>
        )}
      </div>
    </>
  )
}

export default Services
